/**
 * スマヒョメニュー
 */

const spnav = () => {
    const toggle = document.querySelector('.btn-spnav');
    if (!toggle) return;

    toggle.addEventListener('click', toggleHandler, false);
};

const toggleHandler = (event) => {
    const btn = event.currentTarget;
    const nav = document.querySelector('.l-global');
    const className = `open`;

    if (!nav) return;

    btn.classList.toggle(className);
    const hasClass = btn.classList.contains(className);

    if (hasClass) nav.classList.add(className)
    else if (!hasClass) nav.classList.remove(className);
};

window.addEventListener('DOMContentLoaded', spnav, false);


// WEBPACK FOOTER //
// ./js/modules/spnav.js